"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const icons_1 = __importDefault(require("@ant-design/icons"));
// import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'
function IconComponent({ type, ...props }) {
    const component = require(`./custom/${type}`).default;
    return (0, jsx_runtime_1.jsx)(icons_1.default, { ...props, component: component });
}
exports.default = IconComponent;
